import { Link } from '@tanstack/react-router'
import { Wallet } from 'lucide-react'

/** The header's way into the Wallet; the credit balance shows on it only while there is some. */
export function WalletButton({ balance, to }: { balance?: number; to: string }) {
  return (
    <Link
      to={to}
      aria-label="Wallet"
      title="Wallet"
      className="relative flex size-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-card hover:text-foreground"
    >
      <Wallet className="size-4" />
      {balance !== undefined && balance > 0 && (
        <span className="absolute -top-0.5 -right-0.5 flex size-4 items-center justify-center rounded-full bg-[#f97316] text-[10px] font-bold text-white">
          {balance}
        </span>
      )}
    </Link>
  )
}
